
enum HttpErrorMessage {
    tokenExpired = "Context creation failed: Invalid session. Please log-in again!",
}

const Events = ["load", "mousemove", "mousedown", "scroll", "keypress", "resize", "unload", "keyup", "keydown"]

export { HttpErrorMessage, Events }